<template>
  <el-table
    :data="connectDeviceData"
    height='100%'
    style="width: 100%"
  >
    <el-table-column
      v-for="column in connectDeviceColums"
      :key="column.prop"
      :prop="column.prop"
      :label="column.label"
      :width="column.width"
      :minWidth="column.minWidth"
      :maxWidth="column.maxWidth"
      :align="column.align"
      :header-align="column.headerAlign"
      show-overflow-tooltip
      :type="(column.prop === 'netinterfaceObjId') ? 'expand' : ''"
      >
      <template slot-scope="scope">
        <span v-if="column.scopedSlot === 'connDeviceName-slot'" @click="clickObjName(scope.row, $event)" class="link c-pointer">{{ scope.row.connDeviceName }}</span>
        <div v-else-if="column.scopedSlot === 'netinterfaceObjId-slot'">
          <el-row style="padding: 5px 20px;" v-show="scope.row.netinterfaceObjId !== -1">
            <el-col :span="12" v-for="(num, idx) in 2" :key="idx">
              <table class="table-sub-list-info">
                <tr v-for="sub in subInfo(idx)" :key="sub.key">
                  <th>{{ sub.label }}</th>
                  <td>
                    {{ convertValue(scope.row[sub.key], sub.key, isEmpty(sub.formatter) ? '' : sub.formatter) }}
                  </td>
                </tr>
              </table>
            </el-col>
          </el-row>
        </div>
        <span v-else>{{ scope.row[column.prop] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { isEmpty, isNil } from 'lodash';
import { RELATIONSHIP_INFO } from '@/constants/topologymap-major-info';
import { convertValuByUnit } from '@/utils/number';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { Q, MapInfo } from '@/views/topologymap/js/maps';

export default {
  name: 'WConnectDeviceTable',
  props: {
    isObj: {
      type: Boolean,
      default: false,
    },
    objectType: {
      type: String,
      default: 'DEVICE',
    },
    objectInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      RELATIONSHIP_INFO,
      isEmpty,
      connectDeviceData: [],
    };
  },
  computed: {
    connectDeviceColums() {
      let columns = [{ prop: '', label: '', columnKey: '', scopedSlot: '' }];
      columns = RELATIONSHIP_INFO.CONNECT_DEVICE[this.objectType] || [];
      return columns;
    },
    subInfo() {
      return ((idx) => (RELATIONSHIP_INFO.CONNECT_DEVICE_DETAIL[idx]));
    },
  },
  methods: {
    setData(data) {
      this.connectDeviceData = data;
      this.$nextTick(() => {
        this.connectDeviceData.forEach((item, idx) => {
          if (item.netinterfaceObjId === -1 || isNil(item.netinterfaceObjId)) {
            document.getElementsByClassName('el-table__expand-column')[idx + 1].classList.add('hide-sub-info');
          } else {
            document.getElementsByClassName('el-table__expand-column')[idx + 1].classList.remove('hide-sub-info');
          }
        });
      });
    },
    /**
     * 포매터 속은 key값에 따른 값 변환 함수
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} value     [description]
     * @param  {[type]} key       [description]
     * @param  {[type]} formatter [description]
     * @param  {[type]} unit      [description]
     * @param  {[type]} unitText  [description]
     * @return {[type]}           [description]
     */
    convertValue(value, key, formatter, unit, unitText) {
      // formatter 처리
      if (formatter === 'value') {
        let result = '';
        if (isEmpty(unit) && isEmpty(unitText)) {
          result = `${convertValuByUnit(value, '', true, null, true)}`;
        } else {
          result = `${convertValuByUnit(value, unit, true, false, true)}${isEmpty(unitText) ? '' : unitText}`;
        }
        return result;
      } else if (formatter === 'label') {
        if (key === 'netinterfaceStatusOper' || key === 'netinterfaceStatusAdmin') {
          return (value === 1) ? 'UP' : 'DOWN';
        }
      }
      return getValueAfterCheckEmpty(value);
    },
    clickObjName(row) {
      const graph = MapInfo.getInstance(this).getGraph();
      const element = graph.getElement(this.objectInfo.elementId);
      if (element && element instanceof Q.ManagedObjectModel) {
        const elements = [];
        element.forEachEdge((edge) => {
          const edgeModel = edge.get('model');
          if (edge.fromAgent === element) {
            if (row.ifIndex === edgeModel.srcIfIndex && row.connDeviceIp === edge.toAgent.get('ipaddress')) {
              elements.push(edge);
              elements.push(edge.otherNode(element));
            }
          } else if (edge.toAgent === element) {
            if (row.ifIndex === edgeModel.dstIfIndex && row.connDeviceIp === edge.fromAgent.get('ipaddress')) {
              elements.push(edge);
              elements.push(edge.otherNode(element));
            }
          }
        });

        if (elements.length > 0) {
          elements.push(element);
          MapInfo.getInstance(this).highlightElements(elements);
        }
      }
    },
  },
};
</script>
<style lang="scss">
.automap-object.connect-info{
  .el-table__expand-column {
    &.hide-sub-info {
      pointer-events: none;
      .cell {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/components/ConnectDeviceTable.vue